
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import draggable from 'vuedraggable';
import DeleteNationalEventDialog from '@/components/dialogs/calendar/events/DeleteNationalEventDialog.vue';
import { DataTableHeader } from 'vuetify';
import { NationalEventsInterface } from '@/services/Calendar/NationalEvents/Interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    draggable,
    DeleteNationalEventDialog: DeleteNationalEventDialog,
  },
  inject: [
    'nationalEventsRepository',
  ],
})
export default class NationalEventsComponent extends Vue {
  @Prop() private nationalEvents!: NationalEventsInterface[];

  private headers: DataTableHeader[] = [
    { text: 'Name', value: 'name' },
    { text: 'Local Name', value: 'localName' },
    { text: 'Date', value: 'date' },
    { text: 'Type', value: 'type' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];
  private deleteNationalEventDialogData: NationalEventsInterface | false = false;
  private deleteNationalEventDialog: string = '';
  private months: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  private search: string = '';

  private createRecurringEvent(): void {
    this.$router.push({ name: 'calendar_crate_recurring_event' });
  }

  private editRecurringEvent(event: NationalEventsInterface): void {
    this.$router.push({ name: 'calendar_edit_recurring_event', params: { eventId: String(event.id) } });
  }

  private async deleteNationalEvent(event: NationalEventsInterface): Promise<void> {
    this.deleteNationalEventDialogData = event;
    this.deleteNationalEventDialog = 'delete-national-event-dialog';
  }

  private filterNationalEvents(id: number): void {
    this.$emit('filter-national-events', id);
  }
}
